import { ChangeDetectionStrategy, Component, HostListener, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'app-jk-image-viewer',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './jk-image-viewer.component.html',
  styleUrl: './jk-image-viewer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JkImageViewerComponent {
  readonly src = input.required<string>();
  readonly alt = input('圖片預覽');
  readonly zoom = signal(1);
  readonly rotation = signal(0);
  readonly fullscreen = signal(false);

  zoomIn(): void { this.zoom.update(value => Math.min(5, value + 0.25)); }
  zoomOut(): void { this.zoom.update(value => Math.max(0.25, value - 0.25)); }
  rotate(): void { this.rotation.update(value => (value + 90) % 360); }
  fit(): void { this.zoom.set(1); this.rotation.set(0); }
  toggleFullscreen(): void { this.fullscreen.update(value => !value); }

  @HostListener('document:keydown.escape')
  closeFullscreen(): void { this.fullscreen.set(false); }
}
